import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorRulesAppDataProviderFactory } from '../factory/IntegrityMonitorRulesAppDataProviderFactory';
import { IntegrityMonitorRulesAppBaseDataProvider } from '../dataProvider/IntegrityMonitorRulesAppBaseDataProvider';
import { IntegrityMonitorDetailedAssignationData } from '../types';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { Target } from '@nirvana/shared/company-helper/nestjs';

export class IntegrityMonitorRulesAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorRulesAppDataProviderFactory;
  public dataProvider: IntegrityMonitorRulesAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorRulesAppDataProviderFactory(),
    });
  }

  public async getRuleDetailedAssignationData(
    rulesIds: Array<string>
  ): Promise<IntegrityMonitorDetailedAssignationData> {
    return this.dataProvider.getRuleDetailedAssignationData(rulesIds);
  }

  public async removeRecords(records): Promise<any> {
    return this.dataProvider.removeRecords(records);
  }

  public async deleteRuleSet(ruleSetId: string, companyId: string): Promise<Object | null> {
    return this.dataProvider.deleteRuleSet(ruleSetId, companyId);
  }

  public async readRuleOriginal(templateId: string): Promise<IntegrityMonitorRuleGridItem> {
    return this.dataProvider.readRuleOriginal(templateId);
  }

  public async updateNonConfigurableDefaultRule(rule: IntegrityMonitorRuleGridItem): Promise<any> {
    return this.dataProvider.updateNonConfigurableDefaultRule(rule);
  }

  public async getAvailableCompanies(): Promise<Array<Target>> {
    return this.dataProvider.getAvailableCompanies();
  }
}
